import { Col, Container, Row } from 'react-bootstrap'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './ClimateProducts.css'


const ClimateProducts = () => {
    return (
        <main className='climateproducts'>
            <Container>
                <Row>
                    <h2>Nuestros servicios en climatización</h2>
                    <Col md={12} className='my-4'>
                        <VerticalTimeline lineColor={ '#000' }>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Suministro, Instalación y mantenimiento de Sistemas de Climatización para entorno industrial, comercial y sector terciario</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Servicio técnico</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'right'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Desarrollo de Proyectos y Legalizaciones de Instalaciones</p>
                            </VerticalTimelineElement>
                            <VerticalTimelineElement
                                iconStyle={{ background:'#6366f1'}}
                                position={'left'}
                                contentStyle={
                                    {
                                        boxShadow:'none',
                                        textAlign: 'center',
                                        borderRadius: '1em',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }
                                }>
                                <p>Control documental</p>
                            </VerticalTimelineElement>
                        </VerticalTimeline>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default ClimateProducts